import { render, staticRenderFns } from "./OpenJiangLi.vue?vue&type=template&id=78ed2fc6&scoped=true&"
import script from "./OpenJiangLi.vue?vue&type=script&lang=js&"
export * from "./OpenJiangLi.vue?vue&type=script&lang=js&"
import style0 from "./OpenJiangLi.vue?vue&type=style&index=0&id=78ed2fc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ed2fc6",
  null
  
)

export default component.exports